import Vue from "vue";

export default {

    gerarDivulgacao(paramsFiltro) {
        return Vue.axios.post("divulgacao", paramsFiltro);
    }
}